import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import Icon from "../interface/Icon";
import FormGridOptionsPicker from "./FormGridOptionsPicker";

const OPTIONS_IN_ROW = 6;

class FormIconPicker extends React.Component {
  constructor(props) {
    super(props);
  }

  renderOption(opt, selectedValue, onOptionClick, ref, largeIcons) {
    const selected = selectedValue.color === opt.color && selectedValue.icon == opt.icon;
    return (
      <div
        ref={ref}
        className={`iconPickerOption ${selected ? "selected" : ""} ${largeIcons ? "largeIcons" : ""}`}
        key={`${opt.icon}-${opt.color}`}
        onClick={onOptionClick}
      >
        <Icon icon={opt.icon} color={opt.color} />
      </div>
    );
  }

  renderControl(value) {
    return <Icon icon={value.icon} color={value.color} />;
  }

  render() {
    return (
      <FormGridOptionsPicker
        {...this.props}
        classNamePrefix="iconPicker"
        controlRenderer={this.renderControl}
        optionRenderer={this.renderOption}
        optionKeys={["color", "icon"]}
        optionsInRow={OPTIONS_IN_ROW}
      />
    );
  }
}

FormIconPicker.propTypes = {
  options: PropTypeShapes.iconOptionArray.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypeShapes.iconOption,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  backText: PropTypes.string,
  largeIcons: PropTypes.bool
};

export default FormIconPicker;
